import React, { useEffect, useState } from "react";
import { Layout, Table, Typography, message } from "antd";
import axiosInstance from "../api/axiosInstance";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import AppHeader from "./Header";
import { Content } from "antd/es/layout/layout";

const { Title, Text } = Typography;

const MeetingParticipationReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/report/meeting-participation");
      setData(res.data);
    } catch (error) {
      message.error("Gagal mengambil data report");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Cek Kehadiran",
      dataIndex: "cek_kehadiran",
      key: "cek_kehadiran",
    },
    { title: "Hari", dataIndex: "hari", key: "hari" },
    {
      title: "Tanggal, Bulan",
      dataIndex: "tanggal_bulan",
      key: "tanggal_bulan",
    },
    { title: "Jam", dataIndex: "jam", key: "jam" },
    {
      title: "Presensi Rapat",
      dataIndex: "presensi",
      key: "presensi",
      render: (link, record) => <Link to={link}>Presensi</Link>,
    },
    {
      title: "Isu Assign (Poin Penugasan)",
      dataIndex: "isu_meeting",
      key: "isu_meeting",
    },
    {
      title: "Jumlah tindak lanjut",
      dataIndex: "tindak_lanjut",
      key: "tindak_lanjut",
    },
    {
      title: "Skor",
      dataIndex: "skor",
      key: "skor",
      render: (score) => <Text strong>{score}</Text>,
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ marginLeft: 260 }}>
        {/* Menyesuaikan lebar sidebar */}
        <AppHeader />
        <Content
          style={{
            margin: "20px",
            padding: "20px",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <div style={{ padding: "20px" }}>
            <Title level={3} style={{ textAlign: "center" }}>
              Tabel Kerja Pelaksanaan Partisipasi Daily Meeting
            </Title>
            <Table
              columns={columns}
              dataSource={data}
              loading={loading}
              rowKey={(record) => record.id_meeting}
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MeetingParticipationReport;
